import { ValueOfKey } from '../../utils-types';

export const CARD_BRAND = {
  MASTERCARD: 'mastercard',
  VISA: 'visa',
  AMEX: 'amex',
  DINERS: 'diners',
  DISCOVER: 'discover',
  JCB: 'jcb',
  UNIONPAY: 'unionpay',
} as const;

export type CardBrand = ValueOfKey<typeof CARD_BRAND>;

export const humanizeCardBrand: Record<CardBrand, string> = {
  [CARD_BRAND.MASTERCARD]: 'Mastercard',
  [CARD_BRAND.VISA]: 'Visa',
  [CARD_BRAND.AMEX]: 'American Express',
  [CARD_BRAND.DINERS]: 'Diners Club',
  [CARD_BRAND.DISCOVER]: 'Discover',
  [CARD_BRAND.JCB]: 'JCB',
  [CARD_BRAND.UNIONPAY]: 'UnionPay',
};
